export const getFromInitialData = (key, orElse) => {
  const data = __INITIAL_DATA__;
  if (data && data[key]) return data[key];
  else return orElse;
};



// WEBPACK FOOTER //
// ./src/utils/initial-data.js